module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/5_bade27e96ed0d74db41b8212ccb1be07.png";